import * as React from 'react';

export const ImportQuizIcon = (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 9C16 7.89543 16.8954 7 18 7H61C63.2091 7 65 8.79086 65 11V65C65 68.3137 62.3137 71 59 71H20C17.7909 71 16 69.2091 16 67V9Z"
      fill="#E4FBFF"
    />
    <rect
      x="11"
      y="2"
      width="49"
      height="64"
      rx="4"
      stroke="#0099C7"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 11C17.4477 11 17 11.4477 17 12C17 12.5523 17.4477 13 18 13H53C53.5523 13 54 12.5523 54 12C54 11.4477 53.5523 11 53 11H18ZM18 18C17.4477 18 17 18.4477 17 19C17 19.5523 17.4477 20 18 20H45C45.5523 20 46 19.5523 46 19C46 18.4477 45.5523 18 45 18H18Z"
      fill="#0099C7"
    />
    <path
      d="M41.4524 39.4277V49.3271H31.5529"
      stroke="#0099C7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.922 48.7972L28.5476 36.4228"
      stroke="#0099C7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
